var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 31,
    viewBox: "0 0 34 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 0H3.33333C1.5 0 0.0166667 1.5 0.0166667 3.33333L0 29.3C0 30.7833 1.8 31.5333 2.85 30.4833L6.66667 26.6667H30C31.8333 26.6667 33.3333 25.1667 33.3333 23.3333V3.33333C33.3333 1.5 31.8333 0 30 0ZM10 15C9.08333 15 8.33333 14.25 8.33333 13.3333C8.33333 12.4167 9.08333 11.6667 10 11.6667C10.9167 11.6667 11.6667 12.4167 11.6667 13.3333C11.6667 14.25 10.9167 15 10 15ZM16.6667 15C15.75 15 15 14.25 15 13.3333C15 12.4167 15.75 11.6667 16.6667 11.6667C17.5833 11.6667 18.3333 12.4167 18.3333 13.3333C18.3333 14.25 17.5833 15 16.6667 15ZM23.3333 15C22.4167 15 21.6667 14.25 21.6667 13.3333C21.6667 12.4167 22.4167 11.6667 23.3333 11.6667C24.25 11.6667 25 12.4167 25 13.3333C25 14.25 24.25 15 23.3333 15Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSms);
export default __webpack_public_path__ + "static/media/SMS.30983b3785a059742963bcb920043122.svg";
export { ForwardRef as ReactComponent };